import {
    get,
    axios
} from "../ApiDecorator";

/**
 * 研修平台考勤管理 V2
 * 网关：/learn/admin/v2/attendance
 */
const AttendanceV2 = {
    /** GET 已启用阶段（筛选项） */
    getEnabledStages(data) {
        return get("/learn/admin/v2/attendance/enabledStages", data);
    },
    /** GET 每日考勤（明细 / 未打卡） */
    getDaily(data) {
        return get("/learn/admin/v2/attendance/daily", data);
    },
    /** GET 考勤统计汇总 */
    getSummary(data) {
        return get("/learn/admin/v2/attendance/summary", data);
    },
    /** GET 每日考勤导出 CSV（blob） */
    exportDaily(data) {
        const params = { ...data, noCache: new Date().getTime() };
        const query = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== "")
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join("&");
        return axios.get(`/learn/admin/v2/attendance/exportDaily?${query}`, {
            responseType: "blob",
        }).then(res => res.data);
    },
};

export default AttendanceV2;
